"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

require("core-js/modules/es.object.keys.js");

require("core-js/modules/es.array.index-of.js");

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.symbol.description.js");

require("core-js/modules/es.symbol.iterator.js");

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/es.array.slice.js");

require("core-js/modules/es.array.from.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.object.define-property.js");

require("core-js/modules/es.array.filter.js");

require("core-js/modules/es.object.get-own-property-descriptor.js");

require("core-js/modules/es.object.get-own-property-descriptors.js");

require("core-js/modules/es.object.define-properties.js");

require("core-js/modules/es.weak-map.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.array.map.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.array.includes.js");

require("core-js/modules/es.string.includes.js");

require("core-js/modules/es.function.name.js");

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _antd = require("antd");

var _Map = _interopRequireDefault(require("ol/Map"));

var _Style = _interopRequireDefault(require("ol/style/Style"));

var _Vector = _interopRequireDefault(require("ol/layer/Vector"));

var _FeatureGrid = _interopRequireDefault(require("../FeatureGrid/FeatureGrid"));

var _WfsSearchMenuBar = _interopRequireDefault(require("../../../menuBar/wfs/search/WfsSearchMenuBar/WfsSearchMenuBar"));

var _useWFSDescribeFeatureType = _interopRequireDefault(require("../../../../hooks/wfs/useWFSDescribeFeatureType"));

require("./WfsFeatureGrid.css");

var _jsxRuntime = require("react/jsx-runtime");

var _excluded = ["url", "wfsOptions", "fetchOptions", "map", "vectorLayer", "zoomToLayer", "columnDefs", "rowSelection", "featureStyle", "selectedFeatureStyle", "className", "keyFunc", "onSelectionChanged", "onGridReady", "onRowClicked"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var defaultKeyFunction = function defaultKeyFunction(feature) {
  return feature.ol_uid;
};

var defaultColumnDefs = [];
/**
 * <p>
 *  Grid Component to allow to send a WFS Request and load all the features
 *  Retrieved in the response.
 * </p>
 * <p>The following functionalities are present:</p>
 * <ol>
 *  <li>
 *      The <i>Search Type</i> button will allow to select the type of search (by
 *      properties, by point, by BBox, etc...)
 *  </li>
 *  <li>
 *      Each selected "Search Type" will load the needed input controls for the
 *      search. A button will be present to send the WFS Request after the 
 *      needed input values were provided on these input controls.
 *  </li>
 *  <li>All the features returned in the WFS response  will be loaded in the grid.</li>
 *  <li>
 *      The <i>Clear Button</i> will offer the options to remove all loaded features in the grid or
 *      to remove only the feature(s) selected in the grid.
 *  </li>
 *  <li>
 *      The <i>Zoom Button</i> will offer the options to zoom to all features loaded in the grid or
 *      to zoom only to the feature(s) selected in the grid.
 *  </li>
 *  <li>
 *      The unselected feature(s) in the row grid will be rendered
 *      using the style defined in <i>featureStyle</i>.
 *  </li>
 *  <li>
 *      The selected feature(s) in the row grid will be rendered
 *      using the style defined in <i>selectedFeatureStyle</i>.
 *  </li>
 *  <li>
 *      Addional properties not listed below can be passed. See
 *      <a href="https://www.ag-grid.com/react-grid/grid-properties/">documentation</a> 
 *      for more details.
 *  </li>
 * </ol>
 * 
 * @visibleName WFS Feature Grid
 */

var WfsFeatureGrid = function WfsFeatureGrid(_ref) {
  var url = _ref.url,
      wfsOptions = _ref.wfsOptions,
      fetchOptions = _ref.fetchOptions,
      map = _ref.map,
      vectorLayer = _ref.vectorLayer,
      _ref$zoomToLayer = _ref.zoomToLayer,
      zoomToLayer = _ref$zoomToLayer === void 0 ? true : _ref$zoomToLayer,
      _ref$columnDefs = _ref.columnDefs,
      columnDefs = _ref$columnDefs === void 0 ? defaultColumnDefs : _ref$columnDefs,
      _ref$rowSelection = _ref.rowSelection,
      rowSelection = _ref$rowSelection === void 0 ? 'multiple' : _ref$rowSelection,
      featureStyle = _ref.featureStyle,
      selectedFeatureStyle = _ref.selectedFeatureStyle,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? 'ag-theme-balham' : _ref$className,
      _ref$keyFunc = _ref.keyFunc,
      keyFunc = _ref$keyFunc === void 0 ? defaultKeyFunction : _ref$keyFunc,
      onSelectionChanged = _ref.onSelectionChanged,
      onGridReady = _ref.onGridReady,
      onRowClicked = _ref.onRowClicked,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  var _useWFSDescribeFeatur = (0, _useWFSDescribeFeatureType.default)(),
      isLoading = _useWFSDescribeFeatur.isLoading,
      data = _useWFSDescribeFeatur.data,
      error = _useWFSDescribeFeatur.error,
      sendRequest = _useWFSDescribeFeatur.sendRequest;

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      gridApi = _useState2[0],
      setGridApi = _useState2[1];

  var _useState3 = (0, _react.useState)(columnDefs),
      _useState4 = _slicedToArray(_useState3, 2),
      internalColumnDefs = _useState4[0],
      setInternalColumnDefs = _useState4[1]; // const previousColumnDef = usePrevious(columnDefs);
  // if (columnDefs !== previousColumnDef && columnDefs !== internalColumnDefs) {
  //     setInternalColumnDefs(columnDefs);
  // }

  /**
   * Method to build the column definitios from the feature types
   * retrieved from the WFS Service DescribeFeatureType
   * @param {Object} jsonFeatTypes A json object retrieved from 
   *                               the WFS Service DescribeFeatureType
   */


  var buildColumnDefsFromWfsDescribeFeatureTypes = function buildColumnDefsFromWfsDescribeFeatureTypes(jsonFeatTypes) {
    var newColumnDefs = [];

    if (jsonFeatTypes && 'featureTypes' in jsonFeatTypes) {
      //retrieve the first feature type
      var featureTypes = jsonFeatTypes.featureTypes[0].properties;
      featureTypes.forEach(function (featType) {
        //filter out of geometry gml types
        if (!featType.type.includes('gml')) {
          newColumnDefs.push({
            field: featType.name,
            sortable: true,
            filter: true,
            resizable: true
          });
        }
      });
    }

    return newColumnDefs;
  };
  /**
  * Event Handler fired when the grid is ready.
  * This handler will initialize the grid api 
  * in the state
  */


  var onInternalGridReady = (0, _react.useCallback)(function (params) {
    setGridApi(params.api);
    onGridReady && onGridReady(params);
  }, [onGridReady]);
  /**
   * Send a call to WFS DescribeFeatureType to be used later
   * to build the column definitions
  */

  (0, _react.useEffect)(function () {
    //const featureType = 'LoM:WFS_MUN';
    var featureType = wfsOptions.featureTypes[0];

    if ('featurePrefix' in wfsOptions) {
      featureType = wfsOptions.featurePrefix + ':' + featureType;
    }

    sendRequest(url, featureType);
  }, [sendRequest, url, wfsOptions]);
  /**
   * Build the Grid Column definitions from the data retrieved from
   * the WFS service DescribeFeatureType
   */

  (0, _react.useEffect)(function () {
    if ((!internalColumnDefs || internalColumnDefs.length === 0) && data && !isLoading && !error) {
      var newColumnDefs = buildColumnDefsFromWfsDescribeFeatureTypes(data);
      setInternalColumnDefs(newColumnDefs);
    }
  }, [internalColumnDefs, vectorLayer, data, isLoading, error]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "rolext-wfsfeaturegrid"
    /*style={ { height: "100%", width: "100%" } }*/
    ,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_antd.Space, {
      wrap: true,
      className: "rolext-wfsfeaturegrid-menubar-container",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_FeatureGrid.default.MenuBar, {
        map: map,
        layer: vectorLayer,
        gridApi: gridApi
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Divider, {
        type: "vertical"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(WfsFeatureGrid.SearchMenuBar, {
        map: map,
        layer: vectorLayer,
        url: url,
        wfsOptions: wfsOptions,
        fetchOptions: fetchOptions,
        columnDefs: internalColumnDefs
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "rolext-wfsfeaturegrid-content-container"
      /*style={{height:'80%'}}*/
      ,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FeatureGrid.default, _objectSpread({
        map: map,
        vectorLayer: vectorLayer,
        zoomToLayer: zoomToLayer,
        columnDefs: internalColumnDefs,
        rowSelection: rowSelection,
        featureStyle: featureStyle,
        selectedFeatureStyle: selectedFeatureStyle,
        keyFunc: keyFunc,
        onGridReady: onInternalGridReady,
        onSelectionChanged: onSelectionChanged,
        onRowClicked: onRowClicked,
        className: className
      }, otherProps))
    })]
  });
};

WfsFeatureGrid.propTypes = {
  /**
   * The url used for the WFS request
   */
  url: _propTypes.default.string.isRequired,

  /**
   * The WFS options for the WFS GetFeature request.
   * This object has the same format as used in the OpenLayers 
   * <a href="https://openlayers.org/en/latest/apidoc/module-ol_format_WFS-WFS.html">
   * ol/format/WFS.writeGetFeature</a> method.
   */
  wfsOptions: _propTypes.default.object.isRequired,

  /**
   * Additional options to be used for the 
   * <a href="https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API/Using_Fetch">fetch API</a>.
   */
  fetchOptions: _propTypes.default.object,

  /**
   * The OpenLayers map <i>ol/Map</i> where the features will be rendered.
   */
  map: _propTypes.default.instanceOf(_Map.default).isRequired,

  /**
   * The OpenLayers vector layer <i>ol/layer/Vector</i> 
   * where the feature will be rendered.
   */
  vectorLayer: _propTypes.default.instanceOf(_Vector.default).isRequired,

  /**
   * If true, the map will we zoomed to the features in the 
   * layer <i>vectorLayer</i> during the initialization;
   */
  zoomToLayer: _propTypes.default.bool,

  /**
   * <p>Array of <a href="https://www.ag-grid.com/react-grid/grid-properties">Column Definitions.</a></p>
   * <p>
   *  If it is a empty array, all the property names will be shown
   *  in the grid.
   * </p>
   */
  columnDefs: _propTypes.default.array,

  /**
   * Allow a single or multiple row selection in the grid.
   */
  rowSelection: _propTypes.default.oneOf(['single', 'multiple']),

  /**
  * The openLayers style <i>ol/Style</i> used to render the
  * <u>unselected</u> feature(s) in the row grid.
  * If not provided, a default style will be provided
  * by the <i>FeatureGrid</i> component.
  */
  featureStyle: _propTypes.default.instanceOf(_Style.default),

  /**
  * The openLayers style <i>ol/Style</i> used to render the
  * <u>selected</u> feature(s) in the row grid.
  * If not provided, a default style will be provided
  * by the <i>FeatureGrid</i> component
  */
  selectedFeatureStyle: _propTypes.default.instanceOf(_Style.default),

  /**
   * Function to provide a unique identifer for the feature in the map.
   * The default function returns your internal unique identifier (uid).
   */
  keyFunc: _propTypes.default.func,

  /**
   * Event Handler for the event fired once the user selects 
   * one or more rows in the grid. See example below to check
   * how it works.
   */
  onSelectionChanged: _propTypes.default.func,

  /**
   * Event Handler for the event fired once the grid was
   * initialised.
   */
  onGridReady: _propTypes.default.func,

  /**
   * Event Handler for the event fired once a row in the
   * grid is selected.
   */
  onRowClicked: _propTypes.default.func,

  /**
   * The class name to provide different themes.
   * Check the  <a href="https://www.ag-grid.com/react-grid/themes-provided/">available themes.</a>
   * details about available themes.
   */
  className: _propTypes.default.string
};
WfsFeatureGrid.SearchMenuBar = _WfsSearchMenuBar.default;
var _default = WfsFeatureGrid;
exports.default = _default;